<template>
  <wsp-modal>
    <v-card class="pb-5" flat>
      <v-card-title class="pa-0">
        <v-toolbar class="primary" dark dense flat>
          <v-toolbar-title v-html="$t('parkingDetail.tooltip.rfid')">
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-list class="n-lines">
          <v-list-tile avatar class="mt-2">
            <v-list-tile-content>
              <v-list-tile-title class="mb-1">{{
                $t('parkingAccessType.rfid.point1.title')
              }}</v-list-tile-title>
              <v-list-tile-sub-title>
                <span>{{ $t('parkingAccessType.rfid.point1.line1') }}</span
                ><br />
                <span>{{ $t('parkingAccessType.rfid.point1.line2') }}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar class="mt-2">
            <v-list-tile-content>
              <v-list-tile-title class="mb-1">{{
                $t('parkingAccessType.rfid.point2.title')
              }}</v-list-tile-title>
              <v-list-tile-sub-title>
                <span>{{ $t('parkingAccessType.rfid.point2.line1') }}</span
                ><br />
                <span>{{ $t('parkingAccessType.rfid.point2.line2') }}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar class="mt-2">
            <v-list-tile-content>
              <v-list-tile-title class="mb-1">{{
                $t('parkingAccessType.rfid.point3.title')
              }}</v-list-tile-title>
              <v-list-tile-sub-title>
                <span>{{ $t('parkingAccessType.rfid.point3.line1') }}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar class="mt-2">
            <v-list-tile-content>
              <v-list-tile-title class="mb-1">{{
                $t('parkingAccessType.rfid.point4.title')
              }}</v-list-tile-title>
              <v-list-tile-sub-title>
                <span>{{ $t('parkingAccessType.rfid.point4.line1') }}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';

export default {
  name: 'InformationRfidModal',
  components: {
    [WspModal.name]: WspModal
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    }
  },
  computed: {},
  data() {
    return {
      visible: true
    };
  },
  methods: {}
};
</script>
